<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <h1 class="docs__title">Terms of Service Agreement</h1>
        <p>This legally binding agreement ("Terms") governs your use of our services, whether for personal or business purposes. By accessing our services, you confirm your full understanding and acceptance of these Terms. If you disagree with any provision, you must immediately cease all use of our services.</p>
        <div class="docs__block">
          <h6>1. Service Overview</h6>
          <p>LUNATRIX LTD specializes in developing digital solutions including website creation, design, and software consulting services.</p>
        </div>
        <div class="docs__block">
          <h6>2. Jurisdictional Compliance</h6>
          <p> Our services are not intended for use in jurisdictions where such use would violate local laws. Users accessing our services from restricted locations do so at their own initiative and assume full responsibility for compliance with applicable local regulations.</p>
        </div>
        <div class="docs__block">
          <h6>3. Data Usage Agreement</h6>
          <p>By using our services, you authorize us to process and store your information in accordance with our Privacy Policy. Any feedback or suggestions you provide may be used by us without compensation or restriction.</p>
        </div>
        <div class="docs__block">
          <h6>4. Data Management</h6>
          <p>We maintain user data to ensure proper website functionality and performance. While we implement regular data backup procedures, users remain solely responsible for their data. We disclaim liability for any data loss or corruption, and users waive all related claims against us.</p>
        </div>
        <div class="docs__block">
          <h6>5. Usage Restrictions</h6>
          <p>Users may only utilize our services for their intended purpose. Commercial use requires our explicit authorization. Prohibited activities include, but are not limited to:</p>
          <ul>
            <li>- Unauthorized data collection or compilation</li>
            <li>- Any action that may impair service functionality</li>
            <li>- Harassment of other users or our personnel</li>
            <li>- Circumvention of security measures</li>
            <li>- Unauthorized modification or reverse engineering of our software (except where permitted by law)</li>
          </ul>
        </div><div class="docs__block">
          <h6>6. Service Modifications</h6>
          <p> We reserve the right to modify or discontinue services at any time without notice. We are not obligated to maintain or update service content and assume no liability for any resulting impact on users.  Service Availability. While we strive to maintain continuous service availability, we cannot guarantee uninterrupted access due to potential technical issues or maintenance requirements. Users acknowledge that we are not liable for service interruptions.</p>
        </div>
        <div class="docs__block">
          <h6>7. Contact Information</h6>
          <p>For service-related inquiries or complaints, please contact us at: <a href="mailto:info@lunatrixltd.com">info@lunatrixltd.com</a>. This revised version maintains all legal concepts while improving readability and organization. The content is presented in a more structured format with clear section headings, making it easier for users to navigate and understand the terms. Legal terminology has been preserved where necessary while simplifying complex phrases where possible without losing meaning.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.docs {
  padding-block: 80px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__title {
    color: #272343;
    font-size: 48px;
    font-weight: 900;
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & h6 {
    color: #272343;
    font-size: 24px;
    font-weight: 900;
  }

  & p {
    color: #636270;
    font-size: 20px;
    font-weight: 400;
  }

  & li {
    color: #636270;
    font-size: 20px;
    font-weight: 400;
  }

  & a {
    color: #272343;
    font-size: 20px;
    font-weight: 600;

    @include hover {
      color: #19172c;
    }
  }
}

ul {
  padding-left: 30px;
}

@media (max-width: 650px) {
  .docs {
    &__title {
      font-size: 32px;
    }

    & h6 {
      font-size: 18px;
    }

    & p {
      font-size: 14px;
    }

    & li {
      font-size: 14px;
    }

    & a {
      font-size: 14px;
    }
  }
}
</style>